// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailF":"F_dpuDetailF__Z1qN8"};